import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  articlesLoader,
  contactsLoader,
} from "../Components/Home/Header_Utils/header_utils";

const ArticlesContext = createContext();

export function ArticlesProvider({ children }) {
  const [articlesData, setArticlesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contacts, setContacts] = useState([]);
  


  

  useEffect(() => {
    let isMounted = true;
    (async () => {
    setLoading(true);
    try {
      // fetch both in parallel
      const [articles, contactsData] = await Promise.all([
        articlesLoader(),
        contactsLoader(),
      ]);

      if (isMounted) {
        setArticlesData(articles || []);
        setContacts(contactsData || []);
      }
    } catch (error) {
      console.error("Failed to load articles or contacts:", error);
      if (isMounted) {
        setArticlesData([]);
        setContacts([]);
      }
    } finally {
      if (isMounted) setLoading(false);
    }
  })()
    return () => {
      isMounted = false;
    };
  }, []); // runs once on mount

  const value = useMemo(
    () => ({ articlesData, loading, contacts: contacts[0] }),
    [articlesData, loading, contacts]
  );

  return (
    <ArticlesContext.Provider value={value}>
      {children}
    </ArticlesContext.Provider>
  );
}

export function useArticles() {
  return useContext(ArticlesContext);
}
